module.exports = __webpack_public_path__ + "img/DO.c356288f.png";